/**
 *辅营站外券RN组件
 *入参:
       code（各业务线业务码_Number类型）必传
       rules（需要携带各业务产品规则_Object类型）
       businessLines（埋点所需，接入业务线名称_String类型）必传
       page（埋点所需，接入的页面名称_String类型）必传
 *出参：
 *     方式1：通过传入一个getCouponId函数，以回调函数形式暴露给外部，通过形参可以拿到。
 *     方式2：通过在组件上注册一个ref属性，获取组件内部的idData属性。
 *Author：RLC
*/

import React, { PureComponent } from 'react';// eslint-disable-line no-unused-vars
import {
    View,
    ScrollView
} from 'react-native';

import {
    JDText,
    JDImage,
    JDTouchable,
    JDModal
} from '@jdreact/jdreact-core-lib';

import {
    fy_post
} from '../../../common/fetch';
import {
    fy_mta
} from '../../../common/utils';
import img from './common/img';
import styles from './style/index';

class StandingOutsideCoupon extends PureComponent {
    // static defaultProps = {
    //     couponList: [
    //         {
    //             batchId: 94606683,
    //             beginTime: 1548086400000,
    //             couponId: '31597752159',
    //             couponTitle: '龙眼',
    //             createTime: 1548142795625,
    //             discount: 20,
    //             endTime: 1548950399000,
    //             limitStr: '限购  [苏洪鲜食旗舰店] 店铺部分商品',
    //             pin: 'jd_6ccae2196421c',
    //             quota: 39,
    //             state: 2,
    //             style: 0,
    //             type: 1
    //         }
    //     ]
    // }
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            title: '',
            activeGoodsInstructionList: [],
            isModal: false
        };
        // 对外暴露的list
        this.idData = [];
    }

    render() {
        const { data, isModal } = this.state;

        return (
            data.length
                ? <View>
                    <View >
                        <View style={ styles.head }>
                            <JDText style={ styles.headText }>超值推荐</JDText>
                        </View>
                    </View>
                    <View style={ styles.couponList }>
                        <ScrollView horizontal={ true } showsHorizontalScrollIndicator={ false }>
                            {data.map((item, index) => {
                                return (
                                    <View style={ styles.couponItem } key={ index }>
                                        <JDImage style={ styles.bg } source={ { uri: item.goodsChecked ? img.activeBg : img.bg } } />
                                        <View style={ styles.body }>
                                            <JDTouchable onPress={ () => { this.changeChecked(item); } }>
                                                <JDText style={ styles.bodyTitle }>{item.activeGoodsCoupon.couponName}</JDText>
                                                <JDText style={ styles.bodyInfo }>{item.activeGoodsCoupon.couponSubName}</JDText>
                                            </JDTouchable>
                                            <View style={ styles.bottom }>
                                                <JDText style={ styles.giving }> <JDText style={ { color: '#DE2519' } }>赠送 </JDText>x1</JDText>
                                                <JDTouchable onPress={ () => { this.showModal(item); } }>
                                                    <View style={ styles.iconView } onPress={ this.closeModal }>
                                                        <JDText style={ styles.detailed }>查看详情</JDText>
                                                        <JDImage style={ styles.IconRight } source={ { uri: img.info } } />
                                                    </View>
                                                </JDTouchable>
                                            </View>
                                        </View>
                                    </View>
                                );
                            })}
                        </ScrollView>
                    </View>
                    { isModal && this.modalView()}
                </View>
                : null
        );
    }

    componentDidMount() {
        this.getActiveByGoodsRules();
    }

    componentDidUpdate() {
    }

    // shouldComponentUpdate(nextProps, nextState) {
    //     return nextState.data.length;
    // }

    componentWillUnmount() { }
    // 其他方法...

    // 获取站外券
    getActiveByGoodsRules =() => {
        const { code, rules, businessLines, page } = this.props;
        // console.log('rules', rules);

        // fy_post('assistincome_yf_select_active', {

        fy_post('assistincome_sc_select_active', {
            businessCode: code,
            rules: rules || null
        }).then(res => {
            // console.log(res);
            this.setState({
                data: res.body
            });
            // 可能后端会配置默认选中券
            if (res.body && res.body.length) {
                const initData = res.body.filter((item) => { return item.goodsChecked === 1; });

                if (initData.length) {
                    this.idData = initData.map((item) => { // 后端配置默认选中的数据，需要上报上去。
                        // let eventParam = businessLines + '_' + page + '_' + item.name + '_' + item.activeGoodsCoupon.couponName + '_' + item.goodsChecked;
                        // fy_mta('LifeTravelSys_PackProductCheck', eventParam);
                        return item.id;
                    }) || [];
                    this.props.getCouponId && this.props.getCouponId(this.idData);
                }
                fy_mta('LifeTravelSys_PackExpo', businessLines + '_' + page);
            }
        }).catch(e => {
        });
    }

    changeChecked =(item) => {
        let eventParam = null;
        const { businessLines, page } = this.props;

        this.state.data.forEach(element => {
            if (element.id === item.id) {
                element.goodsChecked = !element.goodsChecked;
                this.selectedArray(element.id);
                eventParam = businessLines + '_' + page + '_' + item.name + '_' + item.activeGoodsCoupon.couponName + '_' + element.goodsChecked;
                fy_mta('LifeTravelSys_PackProductCheck', eventParam);
            }
        });
        this.forceUpdate();
    }

    // 回调函数对外暴露
    selectedArray = (id) => {
        const index = this.idData.indexOf(id);

        index > -1 ? this.idData.splice(index, 1) : this.idData.push(id);
        this.props.getCouponId && this.props.getCouponId(this.idData);
    }

    showModal = (item) => {
        const { isModal } = this.state;

        this.setState({
            isModal: !isModal,
            title: item.activeGoodsCoupon.couponName,
            activeGoodsInstructionList: item.activeGoodsCoupon.activeGoodsInstructionList
        });
        const eventParam = item.name + '_' + item.activeGoodsCoupon.couponName;

        fy_mta('LifeTravelSys_PackProductDetail', eventParam);
        const { fyShow } = this.props;

        fyShow(!isModal);
    }

    closeModal = () => {
        const { isModal } = this.state;
        const { fyShow } = this.props;

        this.setState({
            isModal: !isModal
        });
        fyShow(!isModal);
    }

    // 关闭弹窗
    modalView = () => {
        const { title, activeGoodsInstructionList, isModal } = this.state;

        return (
            <JDModal
                transparent={ true }
                visible={ isModal
                }>
                <View style={ styles.container }>
                    <View style={ styles.modalBody }>
                        <View style={ styles.parentCloseImg }>
                            <JDTouchable onPress={ () => { this.closeModal(1); } }>
                                <View style={ { width: 30, height: 30, marginTop: (-15), justifyContent: 'center', alignItems: 'center' } }>
                                    <JDImage style={ styles.closeImg } source={ { uri: img.closeImg } } />
                                </View>
                            </JDTouchable>
                        </View>
                        <JDText style={ styles.modalTitle }>{title}</JDText>
                        {activeGoodsInstructionList && activeGoodsInstructionList.map((item, index) => {
                            return (
                                <View key={ index }>
                                    <JDText style={ styles.modalSubtitle }>{item.title}</JDText>
                                    <JDText style={ styles.modalContainer }>{item.content}</JDText>
                                </View>
                            );
                        })}
                    </View>
                </View>
            </JDModal>
        );
    }
}

export default StandingOutsideCoupon;
